"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextTypeMenu = void 0;
var react_1 = __importDefault(require("react"));
var slate_react_1 = require("slate-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./MenuStyles.css"));
var TextTypeMenu = function (_a) {
    var e_1, _b;
    var filteredButtonConfigs = _a.filteredButtonConfigs, onToolbarEvent = _a.onToolbarEvent, onFocusChange = _a.onFocusChange;
    var editor = (0, slate_react_1.useSlate)();
    var heading1 = filteredButtonConfigs.find(function (_a) {
        var type = _a.type;
        return type === "heading1";
    });
    var heading2 = filteredButtonConfigs.find(function (_a) {
        var type = _a.type;
        return type === "heading2";
    });
    var blockQuote = filteredButtonConfigs.find(function (_a) {
        var type = _a.type;
        return type === "blockQuote";
    });
    var optionsOrder = [heading1, heading2, blockQuote];
    var availableOptions = [];
    try {
        for (var optionsOrder_1 = __values(optionsOrder), optionsOrder_1_1 = optionsOrder_1.next(); !optionsOrder_1_1.done; optionsOrder_1_1 = optionsOrder_1.next()) {
            var b = optionsOrder_1_1.value;
            if (b != undefined) {
                var isActive = b.isActive(editor, { contextualStylesShowing: false });
                availableOptions.push({ buttonConfig: b, isActive: isActive });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (optionsOrder_1_1 && !optionsOrder_1_1.done && (_b = optionsOrder_1.return)) _b.call(optionsOrder_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (availableOptions.length === 0) {
        return null;
    }
    var _c = getMenuButtonContent(availableOptions), menuIcon = _c.menuIcon, menuText = _c.menuText;
    return (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { className: tokens_1.darkTheme, size: kaleidoscope_1.PopoverSize.Auto, padding: "none", button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ className: styles.textTypeMenuButton, type: kaleidoscope_1.ButtonType.Tertiary }, buttonProps),
            menuIcon,
            menuText)); } },
        react_1.default.createElement("div", { onFocus: function (e) { return onFocusChange(e, "textTypeMenu", true); }, onBlur: function (e) { return onFocusChange(e, "textTypeMenu", false); } },
            react_1.default.createElement(kaleidoscope_1.Stack, { padding: "xxs", gap: "xxs" }, availableOptions.map(function (_a) {
                var buttonConfig = _a.buttonConfig, isActive = _a.isActive;
                var eventData = __assign({ button: buttonConfig.type }, buttonConfig.data);
                return (react_1.default.createElement(kaleidoscope_1.Button, { className: styles.menuOptionButton, key: buttonConfig.type, type: kaleidoscope_1.ButtonType.Tertiary, width: "full", onClick: function () { return onToolbarEvent(eventData); }, "aria-pressed": isActive },
                    buttonConfig.content,
                    getTextTypeDisplayName(buttonConfig.type)));
            })))));
};
exports.TextTypeMenu = TextTypeMenu;
function getMenuButtonContent(availableOptions) {
    var firstActive = availableOptions.find(function (_a) {
        var isActive = _a.isActive;
        return isActive === true;
    });
    if (firstActive) {
        var buttonConfig = firstActive.buttonConfig;
        return { menuIcon: buttonConfig.content, menuText: getTextTypeDisplayName(buttonConfig.type) };
    }
    return { menuIcon: react_1.default.createElement(icons_1.Menu, null), menuText: "Text body" };
}
var textTypeDisplayNameMap = {
    heading1: "Title",
    heading2: "Subtitle",
    blockQuote: "Pull quote",
};
function getTextTypeDisplayName(buttonConfigType) {
    var _a;
    return (_a = textTypeDisplayNameMap[buttonConfigType]) !== null && _a !== void 0 ? _a : buttonConfigType;
}
